import { SESDnsRecord } from "@tellescope/tanstack-query";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@tellescope/ui";
import { useTranslation } from "react-i18next";

export interface SESDnsRecordsTableProps {
  records: SESDnsRecord[];
}

export const SESDnsRecordsTable = ({ records }: SESDnsRecordsTableProps) => {
  const { t } = useTranslation("settings");

  return (
    <Table containerClassName="rounded-sm border overflow-hidden">
      <TableHeader className="bg-gray-100">
        <TableRow className="uppercase">
          <TableHead className="h-auto py-2 text-gray-700">{t("Type")}</TableHead>
          <TableHead className="h-auto py-2 text-gray-700">{t("Name")}</TableHead>
          <TableHead className="h-auto py-2 text-gray-700">{t("Value")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {records.map((record) => (
          <TableRow key={`${record.type}-${record.name}-${record.value}`} className="bg-white">
            <TableCell className="py-3 font-mono">{record.type}</TableCell>
            <TableCell className="py-3 font-mono break-all whitespace-normal">{record.name}</TableCell>
            <TableCell className="py-3 font-mono break-all whitespace-normal">{record.value}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
